import { Route } from 'react-router-dom'
import { Welcome } from '../welcome'
import { Steps } from '../steps'
import { VerifyLink } from '../verify-link'
import { SuccessInfoSubmitedForm } from '../success-info-submited-form'
import { Error } from '../error'
import { SuccessInfoChangedRequest } from '../success-info-changed-request'
import { formStepLoader } from '../api/step/step-loader'
import { formDocumentLoader } from '../api/document/document-loader'
import { TenantLayout, TenantAppErrorHandler } from '../view/layout/tenant-app-layout'
import React from 'react'
import { queryClient } from '@reapitform/core'

export const TenantPage = () => {
  return (
    <Route>
      <Route
        path=":recipientId"
        element={<TenantLayout />}
        errorElement={<TenantAppErrorHandler />}
        loader={formDocumentLoader(queryClient)}
      >
        <Route index element={<Welcome />} />
        <Route path="steps">
          <Route path=":stepsId" element={<Steps />} loader={formStepLoader(queryClient)} />
        </Route>
        <Route path="broken-link" element={<VerifyLink />} />
        <Route path="succes">
          <Route path="submited" element={<SuccessInfoSubmitedForm />} />
          <Route path="changed-request" element={<SuccessInfoChangedRequest />} />
        </Route>
        <Route path="*" element={<Error />} />
      </Route>
      <Route path="not-found" element={<Error />} />
    </Route>
  )
}
